import { render, staticRenderFns } from "./reports-constructor.vue?vue&type=template&id=0a052e0e&"
import script from "./reports-constructor.vue?vue&type=script&lang=ts&"
export * from "./reports-constructor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports